import React, { HTMLAttributes } from 'react';

import { TextV2 } from 'components/TextV2/TextV2';
import type { IDetailedPromotion } from 'hooks/ProgramPromotion/useProgramPromotion';
import { BANNER_TITLE_TEST_ID } from './BannerTitle.const';

export const BannerTitle: React.FC<
  HTMLAttributes<HTMLElement> & {
    currentPromotion?: IDetailedPromotion;
    children?: never;
    bannerTitle?: string;
  }
> = ({ currentPromotion, bannerTitle, ...props }) => {
  const title = bannerTitle ?? currentPromotion?.promotionDescription;

  if (!title) return null;

  return (
    <TextV2 data-testid={BANNER_TITLE_TEST_ID.title} variant="modern-eyebrow" value={title} {...props} />
  );
};
